import * as TYPE from "../../actions/ActionConstants";

const initialState = {
  loading: false,
  error: false,
  message: "",
  notifications: [],
  notificationById: {},
  totalCount: 0,
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPE.IS_FETCHING:
      return {
        ...state,
        error: false,
        message: "",
        loading: action.payload,
      };
    case TYPE.GET_ALL_NOTIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: "Notifications fetch successfully",
        notifications: action.payload.data,
        totalCount: action.payload.total_count,
      };
    case TYPE.GET_ALL_NOTIFICATION_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: "Error while fetching notifications",
        notifications: [],
      };
    case TYPE.CREATE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: "Error while fetching notifications",
        notifications: [...state.notifications, action.payload],
      };
    case TYPE.CREATE_NOTIFICATION_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: "Notification fetch successfully",
      };
    case TYPE.GET_NOTIFICATION_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: "Error while fetching notification",
        notificationById: action.payload,
      };
    case TYPE.GET_NOTIFICATION_BY_ID_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: "Error while fetching notification",
        notificationById: {},
      };
    case TYPE.USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
};
export default notificationReducer;
